import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ status: 'loading', user: null });

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/api/auth/me');
      setState({ status: 'authed', user: res.data.user });
    } catch {
      setState({ status: 'anon', user: null });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const res = await api.post('/api/auth/login', { email, password });
    setState({ status: 'authed', user: res.data.user });
    return res.data;
  };

  const register = async (payload) => {
    const res = await api.post('/api/auth/register', payload);
    setState({ status: 'authed', user: res.data.user });
    return res.data;
  };

  const logout = async () => {
    await api.post('/api/auth/logout');
    setState({ status: 'anon', user: null });
  };

  return (
    <AuthContext.Provider value={{ ...state, refresh, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
